import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { translate } from '../../../../../utils/util';
import ListLotItemGeneral from './ListLotItemsGeneral';
import { Title, Subtitle, BackButton } from '../../../../../components/UI/ComponentsUI';

const LotItemGeneral = (props) => {
    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={translate('inventory', 'inventory')} />
                    <Subtitle icon="mdi mdi-clipboard-list-outline" label={translate('general.menu.lot', 'inventory')} />
                    <Subtitle icon="mdi mdi-clipboard-list" label={translate('general.menu.lotItems', 'inventory')} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <ListLotItemGeneral data={props} />
            </div>
        </div>
    );
};

export default withRouter(withTranslation()(LotItemGeneral));
